export default __webpack_public_path__ + "static/media/netlify.58e624b3.png";